import { Button, Flex, Tooltip, theme } from '@aloft/toolkit-sui';
import { PDFViewer } from '@react-pdf/renderer';

import { memo } from 'react';

import { LoadingScreen } from '../../../components/LoadingScreen/LoadingScreen.tsx';
import { selectIncludeCostApproach } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { usePdfReportData } from '../../appraisalReport/index.ts';
import { Tkv2PDFModule } from '../../tkv2PDF/Tkv2PDFModule.tsx';
import { PdfPreviewSnapshot, usePdfPreviewSnapshot } from './usePdfPreviewSnapshot.ts';

const PinnedPdfPreview = memo(({ snapshot }: { snapshot: PdfPreviewSnapshot }) => (
  <PDFViewer showToolbar={false} style={{ width: '100vw', height: '100%' }}>
    <Tkv2PDFModule {...snapshot.data} tkv2ChartImages={snapshot.chartImages} signatureImages={{}} />
  </PDFViewer>
));

export const PdfSheet = () => {
  const { data: liveData, hasCompletedPhotoFetch } = usePdfReportData();
  const includeCostApproach = useAppSelector(selectIncludeCostApproach);
  const { snapshot, isStale, isRefreshing, refresh } = usePdfPreviewSnapshot(
    liveData,
    includeCostApproach,
    hasCompletedPhotoFetch,
  );

  return (
    <Flex width="100%" height="100%" position="relative">
      <Flex position="absolute" top="8px" right="8px" zIndex={theme.zIndices.overlay}>
        <Tooltip label={isStale ? 'Preview is out of date' : 'Preview is up to date'}>
          <Button
            icon="refresh"
            text="Refresh"
            size="sm"
            variant={isStale ? 'primary' : 'secondary'}
            disabled={!isStale}
            isLoading={isRefreshing}
            onClick={refresh}
          />
        </Tooltip>
      </Flex>
      {!snapshot ? (
        <LoadingScreen overrideText="Preparing your report preview..." />
      ) : (
        <PinnedPdfPreview snapshot={snapshot} />
      )}
    </Flex>
  );
};
